import { CSSObject } from '@chakra-ui/react';
import bg from '../../../../../../assets/puntgenie/images/bannerBg.png';
import { BannerSchema } from '@/views/account/Overview/components/Banner/styles/Banner.styles';

export const bannerStyles: BannerSchema = {
  buttonDeposit: {
    h: 8,
    fontSize: 'xs',
    borderRadius: 'lg',
  },
};

export const FlexBannerContainer: CSSObject = {
  bg: ` url(${bg}) center/cover`,
  borderRadius: 'lg',
  color: 'white',
  gap: ['2', null, '0'],
  p: ['2', null, '4'],
  textShadow: '0 2px 5px rgba(0, 0, 0, .25)',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)',
};

export const FlexAccountDetails: CSSObject = {
  alignItems: [null, null, 'center'],
  flexDir: ['column', null, 'row'],
  gap: '1',
};

export const FlexAccountName: CSSObject = {
  color: 'delta.500',
  fontSize: ['lg', null, 'xl'],
  fontWeight: 'semibold',
};

export const FlexAccountBalances: CSSObject = {
  gap: '8',
};

export const FlexBannerBalanceInner: CSSObject = {
  flex: ['1', null, '0 1 auto'],
};

export const TextAccountBalanceLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
  mb: '0.5',
  textTransform: 'uppercase',
};

export const FlexAccountBalanceWrapper: CSSObject = {
  color: 'delta.500',
  display: 'block',
  fontWeight: 'black',
  lineHeight: 'none',
};

export const TextAccountBalanceCurrencySymbol = (): CSSObject => ({
  display: 'inline',
  fontSize: ['sm', null, 'xs'],
  verticalAlign: 'super',
});

export const TextAccountBalanceBaseUnit = (): CSSObject => ({
  fontSize: ['2xl', null, '2xl'],
});

export const TextAccountBalanceSubUnit = (): CSSObject => ({
  fontSize: ['lg', null, 'md'],
  opacity: '0.7',
});

export const FlexButtonContainer: CSSObject = {
  flexDir: ['column', null, 'row'],
  gap: '2',
};

export const FlexBalanceBetInfo: CSSObject = {
  alignItems: 'center',
  border: '2px',
  borderRadius: 'lg',
  boxShadow: '0 2px 6px rgba(0, 0, 0, .2)',
  flex: ['1', null, '0'],
  fontSize: '2xs',
  fontWeight: 'extrabold',
  h: ['10', null, '8'],
  justifyContent: 'center',
  p: '1.5',
  textAlign: 'center',
  textShadow: '0 2px 3px rgba(0, 0, 0, .2)',
  textTransform: 'uppercase',
  whiteSpace: [null, null, 'nowrap'],
};
